module.exports = __webpack_public_path__ + "media/images/application2/AppUsersAnnouncement__header__a-5f74e5de12311863c8c3c130aa8ed20f.svg";